// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"531":"9df58e54","787":"63cc91fc"}[chunkId] + ".chunk.js";
};